import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Education: React.FC = () => (
  <div className="sf-education">
    <section className="sf-education-intro tw-py-[clamp(3rem,6vw,5rem)]">
      <Container className="sf-education-container">
        <p className="sf-education-eyebrow">CURRENT PROGRAMME</p>
        <h1>Education</h1>
        <p className="sf-education-lead tw-max-w-[56rem]">
          Srisailam Foundation currently provides free education and learning support for children studying up to Class 8, helping them build a stronger foundation for their future.
        </p>
      </Container>
    </section>

    <section className="tw-py-[clamp(2.8rem,5vw,4.4rem)]">
      <Container className="sf-education-container">
        <div className="tw-grid tw-gap-6 md:tw-grid-cols-2 md:tw-gap-8">
          <article className="sf-education-card">
            <h2>Our Current Focus</h2>
            <div className="tw-mb-4 tw-h-1 tw-w-12 tw-rounded-full tw-bg-sf-teal" aria-hidden="true" />
            <p>Supporting children's learning through free educational support.</p>
          </article>
          <article className="sf-education-card">
            <h2>Our Vision</h2>
            <div className="tw-mb-4 tw-h-1 tw-w-12 tw-rounded-full tw-bg-sf-gold" aria-hidden="true" />
            <p>We aspire to a future where more children have access to education and opportunities to learn.</p>
          </article>
        </div>
      </Container>
    </section>

    <section className="sf-education-support tw-py-[clamp(2.8rem,5vw,4.4rem)]">
      <Container className="sf-education-container">
        <div className="sf-education-card">
          <h2>Support Our Work</h2>
          <p>Support free education and learning opportunities for children.</p>
          <Link className="sf-education-cta tw-inline-block" to="/donate">Support Our Work</Link>
        </div>
      </Container>
    </section>
  </div>
);

export default Education;
